// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oYdr","rootMobile":"styles_rootMobile__FbG2M"};